<template>
	<div class="skincarekeypoints">
		<Loading msg="loading" v-if="!isload" />
		<div class="keypoints_inner" v-else>
      		<img @click="$parent.routerGo('/')"
				v-lazy="'https://static.inertiabiotech.com/uniskin/reportv3/images/gene_test_back.png'"
				class="back_btn lazy"
				alt="" />
                <h1 class="keypoints_title">检测总结/&nbsp;<span>结合基因和现状，我最需要关注</span></h1>
                <div class="head_part" @click="$parent.routerGo('/skincare',(actParams = { query: $route.query, pageid: 590 }),{is_access:true,reportEvent_page_id:'590',reportEvent_page_name:'护肤方案-检测总结查看详情',reportEvent_report_type:'199基因',reportEvent_first_module:'护肤方案',reportEvent_second_module:'检测总结'})">
                    <h2 class="head_title">{{keypoints_data.title}}</h2>
                    <p class="head_result">{{keypoints_data.title_next}}</p>
                    <div class="check_btn"><span>查看详情</span><img src="../assets/images/arrow_right_c.png" alt=""></div>
                </div>
                <!-- 最强攻略 -->
                <div class="skincare_guide keypoints_2nd_part">
                    <h4 class="part_title">按需攻略/&nbsp;<span>针对性解决皮肤问题</span></h4>
                    <ul class="guide_list list">
                        <li class="list_item" @click="(!pore_survey_done && $parent.routerGo('/poresurvey',(actParams = { query: $route.query, pageid: 591 }),{is_access:true,reportEvent_page_id:'591',reportEvent_page_name:'护肤方案-皮肤问题-毛孔',reportEvent_report_type:'199基因',reportEvent_first_module:'护肤方案',reportEvent_second_module:'皮肤问题',reportEvent_third_module:'毛孔'}));(pore_survey_done && !pore_split && $parent.routerGo('/poreskincareguide',(actParams = { query: $route.query, pageid: 591 }),{is_access:true,reportEvent_page_id:'591',reportEvent_page_name:'护肤方案-皮肤问题-毛孔',reportEvent_report_type:'199基因',reportEvent_first_module:'护肤方案',reportEvent_second_module:'皮肤问题',reportEvent_third_module:'毛孔'}));(pore_survey_done && pore_split && $parent.routerGo('/poreguidearea',(actParams = { query: $route.query, pageid: 591 }),{is_access:true,reportEvent_page_id:'591',reportEvent_page_name:'护肤方案-皮肤问题-毛孔',reportEvent_report_type:'199基因',reportEvent_first_module:'护肤方案',reportEvent_second_module:'皮肤问题',reportEvent_third_module:'毛孔'}))"><img src="../assets/images/keypoints_guide_pore_icon.png" class="item_pic" alt=""><p class="item_name">毛孔</p></li>
                        <li class="list_item" @click="(!sunblock_survey_done && $parent.routerGo('/sunblocksurvey',(actParams = { query: $route.query, pageid: 592 }),{is_access:true,reportEvent_page_id:'592',reportEvent_page_name:'护肤方案-皮肤问题-防晒',reportEvent_report_type:'199基因',reportEvent_first_module:'护肤方案',reportEvent_second_module:'皮肤问题',reportEvent_third_module:'防晒'})),(sunblock_survey_done && $parent.routerGo('/sunblockguide',(actParams = { query: $route.query, pageid: 592 }),{is_access:true,reportEvent_page_id:'592',reportEvent_page_name:'护肤方案-皮肤问题-防晒',reportEvent_report_type:'199基因',reportEvent_first_module:'护肤方案',reportEvent_second_module:'皮肤问题',reportEvent_third_module:'防晒'}))"><img src="../assets/images/keypoints_guide_sunblock_icon.png" class="item_pic" alt=""><p class="item_name">防晒</p></li>
                        <li class="list_item" @click="(!cleanser_survey_done && $parent.routerGo('/cleansersurvey',(actParams = { query: $route.query, pageid: 593 }),{is_access:true,reportEvent_page_id:'593',reportEvent_page_name:'护肤方案-皮肤问题-洁面',reportEvent_report_type:'199基因',reportEvent_first_module:'护肤方案',reportEvent_second_module:'皮肤问题',reportEvent_third_module:'洁面'})),(cleanser_survey_done && $parent.routerGo('/cleanserguide',(actParams = { query: $route.query, pageid: 593 }),{is_access:true,reportEvent_page_id:'593',reportEvent_page_name:'护肤方案-皮肤问题-洁面',reportEvent_report_type:'199基因',reportEvent_first_module:'护肤方案',reportEvent_second_module:'皮肤问题',reportEvent_third_module:'洁面'}))"><img src="../assets/images/keypoints_guide_cleanser_icon.png" class="item_pic" alt=""><p class="item_name">洁面</p></li>
                        <li class="list_item" @click="(!blackheads_survey_done && $parent.routerGo('/blackheadssurvey',(actParams = { query: $route.query, pageid: 594 }),{is_access:true,reportEvent_page_id:'594',reportEvent_page_name:'护肤方案-皮肤问题-黑头',reportEvent_report_type:'199基因',reportEvent_first_module:'护肤方案',reportEvent_second_module:'皮肤问题',reportEvent_third_module:'黑头'})),(blackheads_survey_done && $parent.routerGo('/blackheadsguide',(actParams = { query: $route.query, pageid: 594 }),{is_access:true,reportEvent_page_id:'594',reportEvent_page_name:'护肤方案-皮肤问题-黑头',reportEvent_report_type:'199基因',reportEvent_first_module:'护肤方案',reportEvent_second_module:'皮肤问题',reportEvent_third_module:'黑头'}))"><img src="../assets/images/keypoints_guide_blackheads_icon.png" class="item_pic" alt=""><p class="item_name">黑头</p></li>
                    </ul>
                    <!-- <div class="check_btn"><span>查看更多</span><img src="../assets/images/arrow_right_c.png" alt=""></div> -->
                </div>

                <!-- 场景定制 -->
                <div class="skicnare_scenes keypoints_2nd_part">
                    <h4 class="part_title">场景定制/&nbsp;<span>不同生活场景下的护肤搭配</span></h4>
                    <ul class="scenes_list list">
                         <li class="list_item" @click="$parent.routerGo('/scenariomakeup',(actParams = { query: $route.query, pageid: 595 }),{is_access:true,reportEvent_page_id:'595',reportEvent_page_name:'场景定制 - 经常化妆',reportEvent_report_type:'199基因',reportEvent_first_module:'护肤方案',reportEvent_second_module:'场景护肤',reportEvent_third_module:'经常化妆'})"><img src="../assets/images/scenario_makeup_icon.png" class="item_pic" alt=""><p class="item_name">经常化妆</p></li>
                        <li class="list_item" @click="$parent.routerGo('/scenariomenstrual',(actParams = { query: $route.query, pageid: 596 }),{is_access:true,reportEvent_page_id:'596',reportEvent_page_name:'场景定制 - 生理期',reportEvent_report_type:'199基因',reportEvent_first_module:'护肤方案',reportEvent_second_module:'场景护肤',reportEvent_third_module:'生理期'})"><img src="../assets/images/scenario_menstrual_icon.png" class="item_pic" alt=""><p class="item_name">生理期</p></li>
                        <li class="list_item" @click="$parent.routerGo('/scenariotravel',(actParams = { query: $route.query, pageid: 597 }),{is_access:true,reportEvent_page_id:'597',reportEvent_page_name:'场景定制 - 旅行护肤',reportEvent_report_type:'199基因',reportEvent_first_module:'护肤方案',reportEvent_second_module:'场景护肤',reportEvent_third_module:'旅行护肤'})"><img src="../assets/images/scenario_travel_icon.png" class="item_pic" alt=""><p class="item_name">旅行护肤</p></li>
                        <li class="list_item" @click="$parent.routerGo('/scenariooffice',(actParams = { query: $route.query, pageid: 598 }),{is_access:true,reportEvent_page_id:'598',reportEvent_page_name:'场景定制 - 办公室人群',reportEvent_report_type:'199基因',reportEvent_first_module:'护肤方案',reportEvent_second_module:'场景护肤',reportEvent_third_module:'办公室人群'})"><img src="../assets/images/scenario_office_icon.png" class="item_pic" alt=""><p class="item_name">办公室人群</p></li>
                    </ul>
                    <!-- <div class="check_btn"><span>查看更多</span><img src="../assets/images/arrow_right_c.png" alt=""></div> -->
                </div>

   
		
		</div>

 
	</div>
</template>

<script>
import Loading from "./Loading.vue";
import axios from "axios";
// import sensors from "sa-sdk-javascript";
var wx = require("weixin-js-sdk");
export default {
  name: "SkincareKeyPoints",
  data() {
    return {
      isload: false,
      in_weapp: false, //是否在小程序
      keypoints_data:null,
      pore_survey_done:false,  //是否已经填过毛孔问卷
      pore_split:false,  //毛孔方案是否分区
      sunblock_survey_done:false,  //是否已经填过防晒问卷
      blackheads_survey_done:false,  //是否已经填过黑头问卷
      cleanser_survey_done:false,   //是否已经填过洁面问卷
      cleanser_gene_survey_1:"E"    //洁面涉及基因问卷第一题  若为E 需要填写新增问卷  否则进入方案页面
    };
  },

  created() {
    console.log("skincarekeypoints created", this);
    this.initSkincareKeyPoints();
    this.initPore();   //初始化四类方案  判断问卷填写状态  同时判断师傅分区
    this.initSunblock();
    this.initBlackheads();
    this.initCleanser();
  },
  mounted() {
    var ua = navigator.userAgent.toLowerCase(),
      that = this;
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
      wx.miniProgram.getEnv(res => {
        if (res.miniprogram) {
          console.log("在小程序里");
          that.in_weapp = true;
        }
      });
    }
  },
  methods: {
    goMallDetail: function(pid) {
      if (this.in_weapp) {
        wx.miniProgram.navigateTo({
          url: "/mall-detail/mall-detail?scene=" + pid
        });
      } else {
        location.href =
          "https://www.uniskin.com.cn/homepage/m/pro_detail.html?p=" + pid;
      }
    },
    initSkincareKeyPoints: function() {
      let that = this;
      var local_skincare_key_points = JSON.parse(localStorage.getItem("local_skincare_key_points"));
      if (local_skincare_key_points) {
        afterSkincareKeyPoints(local_skincare_key_points);
      } else {
        that
          .$jsonp(
            "https://www.uniskin.com.cn/reportv2/index/gene_july_one/getSkinMethod"
          )
          .then(json => {
            console.log('keypointsdata',json);
            afterSkincareKeyPoints(json);
            // localStorage.setItem("local_skincare_key_points",JSON.stringify(json));
          })
          .catch(err => {
            console.log(err);
            localStorage.clear();
            location.href =
              "https://www.uniskin.com.cn/mall/member/account/login";
          });
      }
      function afterSkincareKeyPoints(keypoints_data) {
        if (keypoints_data.code == 0) {
          that.isload = true;
          that.keypoints_data = keypoints_data.skin_method_info;
        }else if(keypoints_data.code == 100){
            alert("请先登录");
             location.href = "https://www.uniskin.com.cn/mall/member/account/login";
        }
      }
    },
    initPore: function() {
            let that = this;
            that
            .$jsonp(
            "https://www.uniskin.com.cn/reportv2/index/report199_ex1/getPoreSolution"
            )
            .then(json => {
            console.log('poredata',json);
            if(json.code == 0){
                that.pore_survey_done = true;
                if(json.data.face_desc){
                    that.pore_split = true;
                }else{
                    that.pore_split = false;
                }
            
            }else{
                  that.pore_survey_done = false;
            }
             
            
            })
            .catch(err => {
            console.log(err);
             that.pore_survey_done = false;
            });
            
        },
        initSunblock:function(){
            let that = this
            that.$jsonp("https://www.uniskin.com.cn/reportv2/index/report199_ex1/getAnsResult")
            .then(json => {
            console.log('sunblockdata',json);
            if(json.code == 0){
                 that.sunblock_survey_done = true;
                 
            }else{
                 that.sunblock_survey_done = false;
            }
           

            })
            .catch(err => {
            console.log(err);
            that.sunblock_survey_done = false;
            });
        },
        initBlackheads:function(){
            let that = this
            that.$jsonp("https://www.uniskin.com.cn/reportv2/index/report199_ex1/getBlackHeadSolution")
            .then(json => {
            console.log('blackheadsdata',json);
            if(json.code == 0){
                 that.blackheads_survey_done = true;
            }else{
                 that.blackheads_survey_done = false;
            }
           

            })
            .catch(err => {
            console.log(err);
            that.blackheads_survey_done = false;
            });
        },
        initCleanser:function(){
            let that = this
            that.$jsonp("https://www.uniskin.com.cn/reportv2/index/report199_ex1/getCleanserRecommendGoods")
            .then(json => {
            console.log('cleanserdata',json);
            if(json.code == 0){
                 that.cleanser_survey_done = true;
            }else{
                 that.cleanser_survey_done = false;
            }
           

            })
            .catch(err => {
            console.log(err);
            that.cleanser_survey_done = false;
            });
        },
    displayIng: function(ing) {
      this.show_ing = true;
      this.ing_obj = ing;
    },

    initActionLog: function(m, pageid) {
      if (m && pageid)
        return axios.get("/mall/member/reportV2/actionlog", {
          params: { m, pageid }
        });
    }
  },
  components: {
    Loading
  }
};
</script>
<style lang="less" scoped>
@import "../styles/mixin.less";
@import "../styles/reset.less";
.keypoints_inner{
    background:@bg_c_m;
    padding:126/50rem 30/50rem 169/50rem;
}
.back_btn{
    position:fixed;
    top:0.6rem;
    left:0;
    width:2.36rem;
    height:1.08rem;
    z-index:888;
}
.keypoints_title{
    padding-bottom:32/50rem;
    font-size:44/50rem;
    font-weight:bold;
    line-height:1em;
    color:@font-c-3;
    span{
        font-weight:normal;
        font-size:28/50rem;
        line-height:1em;
        color:@font-c-6;
    }
}
.head_part{
    width:100%;
    .shadow;
    .border-radius(14/50rem);
    box-sizing:border-box;
    background:@bg_c_l;
    padding:60/50rem 24/50rem 40/50rem;
    margin-bottom:16/50rem;
    .head_title{
        text-align:center;
        line-height:1em;
        font-size:34/50rem;
        font-weight:bold;
        color:@font-c-detail;
        padding:0 40/50rem 14/50rem;
    }
    .head_result{
        text-align:center;
        font-size:24/50rem;
        line-height:28/50rem;
        color:@font-c-3;
        padding:0 40/50rem 26/50rem;
    }
    .check_btn{
        .display_flex;
        .flex-wrap_nowrap;
        .justify-content_flex-end;
        span{
            .align-self_center;
            font-size:28/50rem;
            line-height:1em;
            color:@font-c-detail;
        }
        img{
            margin-left:20/50rem;
            .align-self_center;
            width:14/50rem;
            height:27/50rem;
        }
    }
}
.keypoints_2nd_part{
    padding-top:62/50rem;
    .part_title{
        font-size:44/50rem;
        font-weight:bold;
        line-height:1em;
        color:@font-c-3;
        span{
            font-size:30/50rem;
            font-weight:normal;
            line-height:1em;
            color:@font-c-6;
        }
    }
    .list{
        padding:53/50rem 0 40/50rem;
        .display_flex;
        .flex-wrap_nowrap;
        .justify-content_flex-justify;
        .list_item{
            width:150/50rem;
            .item_pic{
                width:150/50rem;
                height:150/50rem;
                .border-radius(15/50rem);
                .shadow;
            }
            .item_name{
                padding-top:15/50rem;
                font-size:28/50rem;
                line-height:1em;
                color:@font-c-6;
                text-align:center;
            }
        }
    }
    .check_btn{
        .display_flex;
        .flex-wrap_nowrap;
        .justify-content_flex-end;
        span{
            .align-self_center;
            font-size:28/50rem;
            line-height:1em;
            color:@font-c-detail;
        }
        img{
            margin-left:20/50rem;
            .align-self_center;
            width:14/50rem;
            height:27/50rem;
        }
    }
}

</style>
